import React from 'react';
import { Icon } from '@landing/ui';

import * as styles from './Contacts.module.scss';

function Contacts({ className }) {
  const phone = '+447809570238';
  const email = 'vn@andersenlab.com';

  return (
    <div className={className}>
      <a href={`tel:${phone}`} className={styles.contact}>
        <Icon name="phone" className={styles.icon} />
        <span className={styles.contactText}>{phone}</span>
      </a>
      <a href={`mailto:${email}`} className={styles.contact}>
        <Icon name="email" className={styles.icon} />
        <span className={styles.contactText}>{email}</span>
      </a>
    </div>
  );
}

export default Contacts;
